import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Stack } from '@mui/material';
import { getFactoringRequestsReceivedToApprove } from 'lib/api/factoring';
import {
  formatDateString,
  formatMoney,
  getShortString,
} from 'lib/functions/utils';
import {
  BoxItemStack,
  ContentCard,
  getFactoringStatusChipType,
  getFactoringStatusLabel,
  StatusChipType,
} from 'lib/mobileDesignSystem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const FactoringApprovalPending: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { data: requests = { data: [] }, isLoading } =
    getFactoringRequestsReceivedToApprove(dispatch, { enabled: true });

  const itemsWithNavigation = (requests?.data ?? []).map((item) => ({
    primaryText: getShortString(item.businessName, 20),
    amount: formatMoney(item.amount),
    secondaryText:
      formatDateString(item.createdAt) + ' · ' + item.recipientName,
    chips: [
      {
        text: item.id.toString(),
        type: 'error' as StatusChipType,
      },
      {
        text: getFactoringStatusLabel(item.status),
        type: getFactoringStatusChipType(item.status),
      },
    ],
    onClick: () => navigate(`/finance/factoring/${item.id}`),
  }));

  return (
    <Stack spacing={2}>
      <ContentCard
        headerColor="warning"
        header={{
          icon: <WarningAmberIcon sx={{ fontSize: 20 }} />,
          title: 'Pendientes de aprobación',
          description: 'Gestiona las solicitudes de factoring.',
        }}
      >
        <BoxItemStack
          items={itemsWithNavigation}
          loading={isLoading}
          skeletonCount={5}
        />
      </ContentCard>
    </Stack>
  );
};

export default FactoringApprovalPending;
